import React, { Component } from 'react';

import SearchInput from '../../../Packages/SharedComponents/Com.Gyf.WebCore.SearchInput.jsx';

import { GenericOption, GenericSelect } from 'com-gyf-webcore-userinterfacecomponents';

class TableHeader extends Component {

    constructor(props) {
        super(props);

        this.state = {
            searchPerfil: ""
        }

        this.limpiarFiltro = this.limpiarFiltro.bind(this);
    }

    limpiarFiltro() {
        this.setState({ searchPerfil: "" });
        this.props.buscarPerfil("");
    }


    render() {
        let props = this.props;

    let oProducts = props.productos.map(function (producto) {
        return <GenericOption id={producto.Id} description={producto.Descripcion} key={"ProdOp_" + producto.Id} />
    });

    let categorias = props.categorias.filter(x => x.Id == 0 || x.ProductoId == props.filter.product);
    let oCategories = categorias.map(function (categoria) {
        return <GenericOption id={categoria.Id} description={categoria.Descripcion} key={"CatOp_" + categoria.Id} />
    });

    let programas = props.programas.filter(x => x.Id == 0 || x.CategoriaId == props.filter.category);
    let oPrograms = programas.map(function (programa) {
        return <GenericOption id={programa.Id} description={programa.Descripcion} key={"ProgOp_" + programa.Id} />
    });

    let searchInputAttr = {
        maxLength: 40,
        className: "form-control default-input",
        placeholder: "Buscar por nombre...",
        value: this.state.searchPerfil
    };

    return (
        <thead>
            <tr>
                <th className="th1">
                    <label>
                        PERFIL
                    </label>
                    <input className="form-control default-input PerfilesYPermisos-searchPerfil" placeholder="Filtro por nombre..." type="text" name="login" id="login"
                        value={this.state.searchPerfil} maxLength="50" onChange={(event) => this.handleChange(event)} />

                    {this.state.searchPerfil.length > 0 ?
                    <div className="PerfilesYPermisos-btn-group-Borrar-Filtro">
                        <button id={"botonBorrarFiltroBuscarEntidad"} type="button" className="btn-tag PerfilesYPermisos-Filtros-Limpiar-Filtro"
                            onClick={this.limpiarFiltro}>
                            <span id={"botonBorrarXFiltroBuscarEntidad"} className="ti-close span-closable" />
                        </button>
                    </div>
                    :
                    null}
                </th>
                <th className="th2">
                    <label>
                        PERMISOS EN
                </label>
                </th>
                <th className="th3 bottom-padding-xxs">
                    <GenericSelect id="selProductos" options={oProducts} value={props.filter.product} onChange={(e) => { props.selectProducto(e.target.value) }}
                        className={"form-control default-select"} />
                </th>
                <th className="th3 bottom-padding-xxs">
                    <GenericSelect id="selCategoria" options={oCategories} onChange={(e) => { props.selectCategoria(e.target.value) }}
                        className={"form-control default-select"} />
                </th>
                <th className="bottom-padding-xxs">
                    <GenericSelect id="selProgramas" options={oPrograms} onChange={(e) => { props.selectPrograma(e.target.value) }}
                        className={"form-control default-select"} />
                </th>
            </tr>
        </thead>
    );
}
    handleChange(event) {
        const term = event.target.value;
        this.setState({ searchPerfil: term });

        this.props.buscarPerfil(term.toUpperCase());
        
    }
}

export default TableHeader;